// Although this function does not need to be async, it's native counterpart does and we'd like to keep a consistent interface
export const getDeviceId = async () => window.mParticle.getDeviceId();
